
export default {
  name: 'PageLogin',

  head() {
    return {
      title: this.$t('signIn')
    }
  },

  mounted() {
    if (this.$app.isAuth) {
      this.$log.debug('Already authed, redirecting to home away from login')

      this.$redirect.to('/platform')
    }
  },

  methods: {
    onAuthenticated() {
      return this.$redirect.to('/platform')
    }
  }
}
